import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { SuccessDialogComponent } from '../success-dialog/success-dialog.component';
import { ConfirmationDialogBoxComponent } from '../confirmation-dialog-box/confirmation-dialog-box.component';
import { Subscription } from 'rxjs';
import { DialogPosition, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WidgetConfigService } from 'src/app/core/services/widget-config.service';
import { ApiCallService } from 'src/app/core/services/api-call-service';
import { TokenStorageService } from 'src/app/core/auth/token-storage.service';
import { getdateformatService } from 'src/app/core/services/get-date-format.service';
import { TranslateDynamicText } from 'src/app/shared/pipes/dynamic-translation.pipe';
import { Event, NavigationEnd, Router } from "@angular/router";
import { SnackbarCollection } from 'src/app/core/services/snackbar.service';

@Component({
  selector: 'app-target-specific-customer',
  templateUrl: './target-specific-customer.component.html',
  styleUrls: ['./target-specific-customer.component.css']
})
export class TargetSpecificCustomerComponent implements OnInit {


  validWidgets = null;
  dialogPosition: DialogPosition = {
    top: "0px",
    right: "0px",
  };
  merchantID = this.tokenService.getMerchantId();
  revenueTime = "ALL";
  numberOfOrdersTime = "ALL";
  pageSize = 10;
  pageIndex = 1;
  customers = [];
  popupElementID;
  totalCustomers;
  sortBy = "";
  filters = {
    segments: [],
  };
  showCustomers = "all";
  searchValue = "";
  filterSegments = [];
  selectedSortBy = "Desc";
  timeout;
  sub: Subscription;
  @ViewChild("search") searchElement: ElementRef;
  revCurrency;
  mobileView;
  mobileMedia = window.matchMedia("(max-width: 896px)");
  segments = {};
  loading = true;
  overallTotalCustomers=null;
  selectedCustomer = []; 
  submit = false;
  currentUrl = "";
  selectedCustomerDetails;
  selectedSearchType = "mobileNumber";
  searchTypeList = [
    { value: "firstName", display: "First Name" },
    { value: "lastName", display: "Last Name" },
    { value: "mobileNumber", display: "Mobile Number" },
    { value: "emailAddress", display: "Email Address" },
    { value: "posId", display: "Customer Id" },
  ];

  
  constructor(
    private dialogRef: MatDialogRef<TargetSpecificCustomerComponent>,
    private _WidgetConfigService: WidgetConfigService,
    private apiCall: ApiCallService,
    private tokenService: TokenStorageService,
    private date_format: getdateformatService,
    private dialog: MatDialog,
    private _i18nDynamicTranslate: TranslateDynamicText,
    private router: Router,
    private snackBar: SnackbarCollection
  ) {
    window["screen-name"] = "ALL CUSTOMERS";
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url.split(";")[0];
      }
    });
  }

  @HostListener("document:click", ["$event"])
  closeSegmentsDiv() {
    let ele = document.getElementById(this.popupElementID);
    if (ele) ele.setAttribute("style", "display:none");
  }
  ngOnInit() {    
    if (this.mobileMedia.matches) {
      this.mobileView = true;
    } else {
      this.mobileView = false;
    }
    this.revCurrency = sessionStorage.getItem("serviceCurrency");
    this.getTotalCustomerCount();
    this.getWidgets();
    this.getCustomers();
    if(localStorage.getItem("searchBy")){
      this.selectedSearchType = localStorage.getItem("searchBy");
    } else {
      this.selectedSearchType = "mobileNumber";
    }
  }


  getSegments() {
    this.apiCall.getAllCustomerSegments().subscribe((response) => {
      JSON.parse(response["body"]).forEach((element) => {
        this.segments[element["id"]] = element["segmentName"];
      });
      // this.loading = false;
    });
  }

  async getWidgets() {
    this.validWidgets = await this._WidgetConfigService.getWidget();
  }

  getCustomers() {
    this.loading = true;
    this.apiCall
      .getCustomersV2(
        this.merchantID,
        this.pageSize,
        this.pageIndex,
        this.filterSegments
      )
      .subscribe((response) => {
        this.showCustomers = "all";
        if (this.mobileView) {
          (response["body"]).forEach((element) => {
            this.customers.push(element);
          });
        } else {
          this.customers = (response["body"]['customerDataList']);
        }
        this.totalCustomers = response["body"]['totalCount'];
        this.customers.forEach((customer)=>{
          if(customer['customerSegments'] && customer['customerSegments'].length>0) {
            customer.segments = customer['customerSegments'].map((segment)=>segment.segmentName);
          } else {
            customer.segments = [];
          }
        });
        this.loading = false;
      },(err)=>{
        this.snackBar.openSnackBar('Failed to fetch custom list',5000);
      });
  }



  showSegments(event, i) {
    let ele = document.getElementById(this.popupElementID);
    if (ele) ele.setAttribute("style", "display:none");
    let id = event.srcElement.parentElement.id;
    event.stopPropagation();
    let element = document
      .getElementById(id)
      .getElementsByClassName("qb-segment-popup")[0];
    element.setAttribute("style", "display:flex");
    this.popupElementID = "popup" + i;
  }

  refreshPaginatedData(event) {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    if (this.showCustomers === "all") this.getCustomers();
    else this.searchCustomer(this.searchValue, false);
  }

  getTotalCustomerCount() {
    
    this.apiCall.getAnalytics(new Date(), new Date()).subscribe((response) => {
      this.totalCustomers = JSON.parse(response["body"]).numberOfCustomers;
      this.overallTotalCustomers=JSON.parse(response["body"]).numberOfCustomers;
    });
  }

  showSearch() {
    this.searchElement.nativeElement.focus();
  }

  onKeySearch(event: any, resetPagination) {
    clearTimeout(this.timeout);
    var $this = this;
    if(event.length !==0){
      this.timeout = setTimeout(function () {
        // if (event.keyCode != 13) {
          $this.searchCustomer(event, resetPagination); //Your function goes here
        // }
      }, 600);
    }
    else{//if search value is 0
     this.getCustomers();
    }
  }

  searchCustomer(searchValue, resetPagination) {
    this.loading = true;
    if (resetPagination) this.pageIndex = 1;
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this.apiCall
      .searchCustomers(
        this.merchantID,
        searchValue,
        this.selectedSearchType,
        this.revenueTime,
        this.numberOfOrdersTime,
        this.pageSize,
        this.pageIndex,
        this.filterSegments
      )
      .subscribe((response) => {
        this.showCustomers = "search";
        if (!this.mobileView) {
          this.customers = (response["body"]['customerDataList']);
        } else {
          if (this.searchValue !== searchValue) {
            this.customers = (response["body"]['customerDataList']);
          } else {
            (response["body"]['customerDataList']).forEach((element) => {
              this.customers.push(element);
            });
          }
        }
        this.searchValue = searchValue;
        this.totalCustomers = response["body"]['totalCount'];
        this.customers.forEach((customer)=>{
          if(customer['customerSegments'] && customer['customerSegments'].length>0) {
            customer.segments = customer['customerSegments'].map((segment)=>segment.segmentName);
          } else {
            customer.segments = [];
          }
        });
        this.loading = false;
      },(err)=>{
        this.snackBar.openSnackBar('Failed to search customer',5000);
      });
  }

  getDateFormat(type?){
    return this.date_format.getDateFormat(type);
  }

    checkWhetherSelected(id){
      if(this.selectedCustomer.indexOf(id) === -1){
        return false;
      }
      else{
        return true;
      }
    }


addCustomerToList(merchantCustomerId,customer) {
  if (this.selectedCustomer!=merchantCustomerId) {
    this.selectedCustomer = merchantCustomerId;
    this.selectedCustomerDetails=customer;
  }
  else if(this.selectedCustomer==merchantCustomerId){
    this.selectedCustomer=[];

  }
}


getDateInFormatForDisplay(dateInp: number): string | null {
  if (!dateInp) return null; 
  let date = new Date(dateInp);
  const year = date.getFullYear();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  return `${month} ${day}, ${year}`;
}


save() {
  this.dialogRef.close({ selectedCustomer: this.selectedCustomer, selectedCustomerDetails: this.selectedCustomerDetails }); // Return the selected customer
}

cancel() {
  this.dialogRef.close();
}

saveValueIntoCacheAndReSearch(searchValue) {
  localStorage.setItem("searchBy", this.selectedSearchType);
  this.onKeySearch(searchValue, true);
}
}
